var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-bar-view"},[_c('alphabet-view',{attrs:{"index":_vm.pagination.index},on:{"update:index":_vm.updateIndex}}),_c('pagination-view',{attrs:{"count":_vm.pagination.count,"page":_vm.pagination.page},on:{"update:page":_vm.updatePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }